<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_ii"></a><a id="page_iii"></a>Master of Space<br/>and Time</h1>
<p class="author"><span><b>by Rudy Rucker</b></span></p>
<p class="author"><span> </span></p>
<p class="publisher"><span><b>THUNDER’S MOUTH PRESS<br/>NEW YORK</b></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?437706f0